import { Injectable } from '@angular/core'
import { BackendResponseFMResp } from '@naturalcycles/shared'
import { api } from '@src/app/core/services/api.service.js'
import { storageService } from '@src/app/core/services/storage.service.js'

@Injectable({ providedIn: 'root' })
export class SessionService {
  public async deleteSession(): Promise<void> {
    await api.delete('sessions')
  }

  async logout(): Promise<void> {
    await this.deleteSession()
    storageService.clear()
    location.reload()
    return
  }

  /**
   * Returns undefined when user is not properly logged in
   * (backend cannot return a proper token).
   *
   * BTW, http GET should not be used here, because the result is non-deterministic
   * (new token every time) and caching it by the browser would be wrong.
   */
  async generateToken(): Promise<string | undefined> {
    const r = await api.get<BackendResponseFMResp>('sessions/token').catch(() => null)
    return r?.backendResponse.res
  }

  async consumeToken(token: string): Promise<string> {
    const { backendResponse } = await api.post<BackendResponseFMResp>('sessions/token', {
      json: { token },
    })
    return backendResponse.res
  }

  async deleteOtherSessions(): Promise<void> {
    await api.delete('sessions/other')
  }
}
